/** Melissa fields that describe state/province subdivisions. */
export interface MelissaCountryAreaFields {
  AdministrativeArea?: string;
  CountrySubdivisionCode?: string;
  ISO3166_2?: string;
}

/**
 * Derives Saleor `countryArea` (subdivision code) from Melissa response fields.
 *
 * For Italy and other ISO 3166-2 countries, Melissa returns `CountrySubdivisionCode`
 * (e.g. `IT-MI`) while `AdministrativeArea` may be a province name. Saleor expects
 * the subdivision suffix (`MI`), not the full name.
 */
export function countryAreaFromMelissa(
  country: string,
  melissa: MelissaCountryAreaFields,
  fallback?: string
): string {
  const subdivisionCode = melissa.CountrySubdivisionCode || melissa.ISO3166_2;
  if (subdivisionCode) {
    const normalizedCountry = country.toUpperCase();
    const [subCountry, ...codeParts] = subdivisionCode.split('-');
    const code = codeParts.join('-');

    if (subCountry.toUpperCase() === normalizedCountry && code) {
      return code;
    }
  }

  return melissa.AdministrativeArea || fallback || '';
}
